import React, { useState, useEffect } from 'react';
import * as yup from 'yup';
import { format } from 'date-fns';
import MDBox from 'components/MDBox';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import { useForm } from 'react-hook-form';
import { GridForm } from 'components/Ui/styled';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';
import { FormInputText } from 'components/Common/Forms/FormTextField';
import { PaperProps, bookSessionSuccess, dateFormatYMD } from 'constants';
import {
  getDialogHeading,
  renderSaveCancelButtons,
  useNotification,
  fieldValidation,
  emptyFunction,
  onSave,
  refinePayload,
} from 'utils/commonUtils';
import { formatDateText } from 'utils/commonUtils';
import { postTutoringSession } from 'layouts/tutoring/services/tutoringApi';

const bookSessionDialogSchema = yup.object().shape({
  reasonForTutoring: fieldValidation(4000),
});

const BookSessionDialog = (props) => {
  const {
    bookSessionDialog,
    setBookSessionDialog,
    bookSessionForm,
    student,
    fetchTutoringAvailability,
  } = props;

  const dispatch = useDispatch();

  const { setOpenNotification, setNotificationMessage, NotificationPopup } =
    useNotification();

  const [loadingButton, setLoadingButton] = useState(false);

  const { startTimeFmt, endTimeFmt, dayOfWeek, timeSlotId } =
    bookSessionForm || {};

  const newSessionFilters = useSelector((state) => state?.newSessionFilters);

  const { studentName, subjectName, date } = newSessionFilters || {};

  const defaultValue = {
    studentName: studentName,
    subjectName: subjectName,
    date: formatDateText(date),
    day: dayOfWeek,
    time: `${startTimeFmt} to ${endTimeFmt}`,
    reasonForTutoring: '',
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(bookSessionDialogSchema),
  });

  const { handleSubmit, control, reset, formState } = useFunction;
  const { errors } = formState;

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.studentName,
    defaultValue.subjectName,
    defaultValue.date,
    defaultValue.day,
    defaultValue.time,
    defaultValue.reasonForTutoring,
  ]);

  const handleClose = () => {
    setBookSessionDialog(false);
    reset(defaultValue);
  };

  const onSubmit = async (data) => {
    const { reasonForTutoring } = data;

    const payload = {
      date: format(new Date(date), dateFormatYMD),
      reason: reasonForTutoring,
      studentId: student?.studentId,
      timeSlotId: timeSlotId,
    };
    onSave(
      bookSessionSuccess,
      true,
      postTutoringSession,
      emptyFunction,
      refinePayload(payload),
      '',
      fetchTutoringAvailability,
      handleClose,
      setOpenNotification,
      setNotificationMessage,
      dispatch,
      setLoadingButton,
      loadingButton
    );
  };

  return (
    <>
      <Dialog open={bookSessionDialog} PaperProps={PaperProps}>
        {getDialogHeading('Book Session', handleClose)}
        <GridForm container spacing={2}>
          <Grid item xs={12}>
            <FormInputText
              name="studentName"
              type="text"
              control={control}
              label="Student Name"
              disabled={true}
            />
            <FormInputText
              name="subjectName"
              type="text"
              control={control}
              label="Subject Name"
              disabled={true}
            />
            <FormInputText
              name="date"
              type="text"
              control={control}
              label="Date"
              disabled={true}
            />
            <FormInputText
              name="day"
              type="text"
              control={control}
              label="Day"
              disabled={true}
            />
            <FormInputText
              name="time"
              type="text"
              control={control}
              label="Time"
              disabled={true}
            />
            <FormInputText
              name="reasonForTutoring"
              type="text"
              control={control}
              label="Reason for Tutoring"
              helperText={errors?.reasonForTutoring?.message}
              errors={!!errors.reasonForTutoring}
              multiline
              rows={2}
            />
            <MDBox mt={1}></MDBox>
            {renderSaveCancelButtons(
              handleClose,
              handleSubmit(onSubmit),
              loadingButton,
              false
            )}
          </Grid>
        </GridForm>
      </Dialog>
      <NotificationPopup />
    </>
  );
};

export default BookSessionDialog;
